// Non-secret, account/service-scoped identifiers. Credentials stay in the vault.
const valid = value => typeof value === 'string' && /^[a-f0-9]{32}$/.test(value);
const key = (address,email) => JSON.stringify([new URL(address).origin,email.trim().toLowerCase()]);
function entries(raw) {
  try {const value=JSON.parse(raw);return Array.isArray(value)?value.filter(row=>Array.isArray(row)&&row.length===2&&typeof row[0]==='string'&&valid(row[1])).slice(-64):[];}catch{return [];}
}
export function readLoginInstallation(raw,address,email) {
  return new Map(entries(raw)).get(key(address,email));
}
export function writeLoginInstallation(raw,address,email,id) {
  if(!valid(id))throw Error('invalid_login_installation');
  const identity=key(address,email),rows=entries(raw).filter(row=>row[0]!==identity);
  return JSON.stringify([...rows,[identity,id]].slice(-64));
}
